import { Injectable } from '@angular/core';

import { AdminProfileState } from 'app/services/shared';

// Empty on purpose: this class exists solely to give the event domain its own
// DI token/instance of AdminProfileState, isolating it from PointOfSaleProfileState
// and UserProfileState. Do not remove or merge into a shared instance.
@Injectable()
export class EventProfileState extends AdminProfileState {}
